export default "__VITE_ASSET__C4s1j$cd__"